export default __webpack_public_path__ + "static/media/about-us-home2.f0c19e3d.webp";